export const noticeConstants = {
  NOTICE_ALL: "NOTICE_ALL"
};
